module.exports = __webpack_public_path__ + "img/index3.6936a03e.png";